import { render } from "./EditAssignation.vue?vue&type=template&id=6f855cb8"
import script from "./EditAssignation.vue?vue&type=script&lang=js"
export * from "./EditAssignation.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__